export interface IntroducingBrokerDto {
  id: string
  name: string | null
  status: { id: number; name: string | null }
  client: Client
  parent: { id: number; name: string | null }
  registeredAt: string
  multiLevelRegisteredAt: string | null
  multiLevelPercentage: number | null
  commissionCalculationStatus: { id: number; name: string | null }
  profile: Profile
  assignee: Assignee | null
  selected: boolean
}

interface Assignee {
  id: string
  name: string
  status: { id: number; name: string }
}

interface Client {
  id: string
  name: string | null
  introducingBroker: IntroducingBroker | null
  tickmillCompany: TickmillCompany
  teams: { id: string; team: string | null }[]
  country?: { id: string; name: string | null }
}

interface TickmillCompany {
  id: number
  name: string | null
}
interface IntroducingBroker {
  name: string | null
  id: string
}

interface Profile {
  id: string
  name: string | null
  description: string | null
  tickmillCompany: { id: number; name: string | null }
}

export enum IntroducingBrokerKey {
  id = 'id',
  name = 'name',
  country = 'client.country.name',
  status = 'status.name',
  client = 'client.name',
  assignee = 'assignee.name',
  tickmillCompany = 'client.tickmillCompany.name',
  parent = 'parent.name',
  registeredAt = 'registeredAt',
  multiLevelRegisteredAt = 'multiLevelRegisteredAt',
  multiLevelPercentage = 'multiLevelPercentage',
  commissionCalculationStatus = 'commissionCalculationStatus.name',
  profile = 'profile.name',
  parentType = 'parentType.name',
}

export enum IntroducingBrokerFilterKey {
  name = 'Name',
  registeredAt = 'RegisteredAt',
  country = 'Country',
  assignee = 'Assignee',
  status = 'StatusId',
  client = 'ClientId',
  tickmillCompany = 'TickmillCompanyId',
  isInternalTestAccount = 'IsInternalTestAccount',
  parentType = 'ParentTypeId',
}
